export default __webpack_public_path__ + "static/media/MQ-start.c10858c3.png";